import * as React from 'react'

const overflowContext = React.createContext<boolean>(false)

const OverflowProvider = overflowContext.Provider
interface Props {
  value: string | number | React.ReactNode
  childrenRef: {
    current: null | HTMLElement
  }
}

export const OverflowContextProvider = ({
  childrenRef,
  value,
  children,
}: React.PropsWithChildren<Props>) => {
  const [isOverflow, setIsOverflow] = React.useState(false)
  React.useEffect(() => {
    if (!childrenRef?.current) return

    const isOverflowing = childrenRef.current.offsetWidth < childrenRef.current.scrollWidth
    setIsOverflow(isOverflowing)
  }, [value, childrenRef])

  return <OverflowProvider value={isOverflow}>{children}</OverflowProvider>
}
